module.exports = __webpack_public_path__ + "img/xinzhuang-2.04cb54b5.jpg";